export class NethoneDetails {
    public inquiryId?: string;

    public feedbackId?: string;
}
